"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaults = void 0;
var version_1 = require("./version");
var constants_1 = require("@splitsoftware/splitio-commons/cjs/utils/constants");
exports.defaults = {
    startup: {
        // Stress the request time used while starting up the SDK.
        requestTimeoutBeforeReady: 5,
        // How many quick retries we will do while starting up the SDK.
        retriesOnFailureBeforeReady: 1,
        // Maximum amount of time used before notifies me a timeout.
        readyTimeout: 10,
        // Amount of time we will wait before the first push of events.
        eventsFirstPushWindow: 10
    },
    // Consent is considered granted by default
    userConsent: constants_1.CONSENT_GRANTED,
    // Instance version.
    version: "javascript-" + version_1.packageVersion,
};
